module.exports = __webpack_public_path__ + "img/avatar.c880bf53.png";